import { render, staticRenderFns } from "./AppIntegrations.vue?vue&type=template&id=bba40424&scoped=true"
import script from "./AppIntegrations.vue?vue&type=script&lang=ts"
export * from "./AppIntegrations.vue?vue&type=script&lang=ts"
import style0 from "./AppIntegrations.vue?vue&type=style&index=0&id=bba40424&prod&scoped=true&lang=css"
import style1 from "./AppIntegrations.vue?vue&type=style&index=1&id=bba40424&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba40424",
  null
  
)

export default component.exports